import classNames from 'classnames';
import Collapsible from 'react-collapsible';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Divider, Row } from 'antd';
import { Routes } from '@/routes';
import { Flex, IcArrow } from '../../common';
import { useModal, useRegisterDormitoryRoom } from '@/hooks';
import RoomCardSolitary from './RoomCardSolitary';
import RoomMembersModal from './RoomMembersModal';
import { useTranslation } from 'react-i18next';

export interface FloorsListProps {
  dormitory: IdName;
  group: DormitoryGroup;
  blockId: number;
  floors: DormitoryFloorEntity[];
  actionMode: 'create' | 'update';
  showMembersEnabled?: boolean;
}

export default function FloorsList({
  dormitory,
  group,
  blockId,
  floors = [],
  actionMode,
  showMembersEnabled
}: FloorsListProps) {

  const navigate = useNavigate();
  const membersModal = useModal();
  const sortedItems = floors.sort((a, b) => a.id - b.id);
  const [t] = useTranslation(['common', 'dormitory']);
  const { solitaryRoomConfirm } = useRegisterDormitoryRoom();

  return (
    <Flex gap="1rem" className="w-full" direction="column">
      <RoomMembersModal {...membersModal} />
      {sortedItems.length === 0 ? (
        <div className="m-auto text-center text-red-500">
          {t('dormitory:errors.not-eligible-in-dormitory')}
        </div>
      ) : (
        floors.map((floor, i) =>
          <FloorCollapsible key={i} name={floor.name}>
            <div className="bg-gray-100 rounded-b-xl">
              <Divider className={classNames('duration-100 transition-opacity !m-0', { 'opacity-0': !open })} />
              <Row className="px-4 py-4" gutter={[12, 12]}>
                {floor.rooms.sort((a, b) => a.id - b.id).map((room, j) => (
                  <RoomCardSolitary
                    key={j}
                    room={room}
                    isSelected={group?.dormitoryRoom?.id === room?.id}
                    onShowMembers={!showMembersEnabled || room?.personCount == 0 ? undefined : () => membersModal.show({ room, blockId, floor, dormitory })}
                    onSelectRoom={() => solitaryRoomConfirm(actionMode, dormitory?.id, room, () => {
                      navigate(Routes.DormitoryRegister);
                    })}
                  />
                ))}
              </Row>
            </div>
          </FloorCollapsible>)
      )}
    </Flex>
  );
}

function FloorCollapsible({ name, children }) {
  const [open, setOpen] = useState(true);
  const classes = classNames('duration-500 transition rounded-t-xl select-none cursor-pointer p-4 bg-gray-100', {
    'rounded-b-xl': !open
  });
  return (
    <Collapsible
      open
      onTriggerOpening={() => setOpen(true)}
      onTriggerClosing={() => setOpen(false)}
      transitionTime={150}
      transitionCloseTime={150}
      trigger={(
        <Flex className={classes} align="center">
          <span className="inline-flex text-lg font-medium">{name}</span>
          <Flex className="pointer-events-auto ms-auto pe-2" inlineFlex>
            <IcArrow className="reactive-collapsible-arrow" type="down" />
          </Flex>
        </Flex>
      )}>
      {children}
    </Collapsible>
  );
}
